import { IcIcon } from '@ic-icons';
import { ButtonSort } from '@shared/forms/elements';
import { SortDirection } from '@shared/interfaces';

export const PEOPLE_SORT: ButtonSort[] = [
  {
    value: 'lastName-asc',
    label: 'SORT.NAME_ASC',
    labelMobile: 'SORT.NAME_ASC_SHORT',
    icon: IcIcon.SortDesc,
  },
  {
    value: 'lastName-desc',
    label: 'SORT.NAME_DESC',
    labelMobile: 'SORT.NAME_DESC_SHORT',
    icon: IcIcon.SortDesc,
  },
];

export const DEFAULT_SORT: ButtonSort[] = [
  {
    value: 'date-desc',
    label: 'SORT.DATE_DESC',
    labelMobile: 'SORT.DATE_DESC_SHORT',
    icon: IcIcon.SortDesc,
  },
  {
    value: 'date-asc',
    label: 'SORT.DATE_ASC',
    labelMobile: 'SORT.DATE_ASC_SHORT',
    icon: IcIcon.SortDesc,
  },
  {
    value: 'firstName-asc',
    label: 'SORT.NAME_ASC',
    labelMobile: 'SORT.NAME_ASC_SHORT',
    icon: IcIcon.SortDesc,
  },
  {
    value: 'firstName-desc',
    label: 'SORT.NAME_DESC',
    labelMobile: 'SORT.NAME_DESC_SHORT',
    icon: IcIcon.SortDesc,
  },
];

export const PERFORMANCES_SORT: ButtonSort[] = [
  {
    value: `order[id]-${ SortDirection.DESC }`,
    label: 'SORT.DATE_DESC',
    labelMobile: 'SORT.DATE_DESC_SHORT',
    icon: IcIcon.SortDesc,
  },
  {
    value: `order[id]-${ SortDirection.ASC }`,
    label: 'SORT.DATE_ASC',
    labelMobile: 'SORT.DATE_ASC_SHORT',
    icon: IcIcon.SortDesc,
  },
  {
    value: `order[popularity]-${ SortDirection.DESC }`,
    label: 'SORT.POPULARITY_DESC',
    labelMobile: 'SORT.POPULARITY_DESC_SHORT',
    icon: IcIcon.SortDesc,
  },
  {
    value: `order[popularity]-${ SortDirection.ASC }`,
    label: 'SORT.POPULARITY_ASC',
    labelMobile: 'SORT.POPULARITY_ASC_SHORT',
    icon: IcIcon.SortDesc,
  }
];
